import { ReactNode } from 'react'

interface DetailPageHeaderProps {
  title: string
  hostInfo: ReactNode
  actions: ReactNode
  sidebar?: ReactNode
}

export const DetailPageHeader = ({
  title,
  hostInfo,
  actions,
  sidebar,
}: DetailPageHeaderProps) => (
  <div className="bg-gray-50">
    <div className="2xl:max-w-[1152px] 2xl:m-auto">
      <section className="lg:flex px-4 md:px-8 lg:px-16 pt-10 lg:pt-16 relative">
        <div className="w-full lg:w-2/3">
          <h3 className="text-gray-800 text-3xl font-bold leading-10">
            {title}
          </h3>
          {hostInfo}
          <div className="w-full lg:w-auto lg:max-w-fit flex flex-col lg:flex-row items-center lg:items-end gap-4 lg:gap-6 lg:mb-12">
            {actions}
          </div>
        </div>
        {sidebar && (
          <div className="hidden lg:flex w-full lg:w-1/3">{sidebar}</div>
        )}
      </section>
    </div>
  </div>
)
